import { LegalEntitySourcesService } from '@festina/legalentity-general-types/legalentity/services/LegalEntitySourcesService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method = LegalEntitySourcesService.legalEntitySourcesServicePostEvents
type MethodParam = Parameters<typeof method>[0]

export const usePostLegalEntitySource = (tenantId: MethodParam['xTenantId']) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: LegalEntitySourcesService.legalEntitySourcesServicePostEvents_roles,
    isScenario: false,
    mutateFunction: (arg: Except<MethodParam, 'xTenantId'>) =>
      method({
        xTenantId: tenantId,
        ...arg,
      }),
  })
